import { render, staticRenderFns } from "./BuyCenter.vue?vue&type=template&id=5a0a11af&scoped=true&"
import script from "./BuyCenter.vue?vue&type=script&lang=js&"
export * from "./BuyCenter.vue?vue&type=script&lang=js&"
import style0 from "./BuyCenter.vue?vue&type=style&index=0&id=5a0a11af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a11af",
  null
  
)

export default component.exports